import React, { useState, useEffect, useRef } from "react";
import CommonObj from "../../CommonObj";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import { message } from "../../components/antdMessageBridge";
import { Modal, Radio, Input } from "antd";
import CuttingIcon from "../../assets/img/svg/xcuttingtitleicon.svg";
import "./cutting.css";
import SliderUI from "../manifest/manifest-slide";
import BatchProcess from "./cutting-batch";
import { Html5QrcodeScanType } from "html5-qrcode";
import BookCoverDummy from "../../assets/img/cover.png";
import { useAuth } from "../../auth/AuthContext";
import { useReworkData } from "../../components/errorCommentsSlider/userreworkdata";
import ErrorCommentsSlider from "../../components/errorCommentsSlider/errorcomments-slider";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import ConfirmationModal from "../../components/confirmationmodal/confirmation-modal";
import regexService, {
    removeSpaces,
} from "../../components/commonregex/regexService";
import validationService from "../../components/commonvalidation/validationService";
import { showManualEntryDisabledWarning } from "../../components/commonvalidation/manualEntryWarning";
import IntakeSlide from "../books/Intake-reject-slide";
import useFieldPermissions from "../../hooks/useFieldPermissions";
const CuttingForm = () => {
    const [form, setForm] = useState({
        bid: "",
        title: "",
        author: "",
        publisher: "",
        isbN10: "",
        isbN13: "",
        bookPageCount: "",
        language: "",
        weight: "0.75",
        isbn: "",
        condition: "",
        content: "",
        bookFormat: "",
        eqComplexityLevel: "",
        rackAndShelf: "1",
        rackShelf: "",
        comments: "",
        bookType: "",
        reasonForException: "",
        newRackShelf: "",
        formatException: "",
        usedCondition: "Acceptable",
        bidScanTime: "",
        vendorName: "",
    });
    const {
        reworkDrawerVisible,
        reworkData,
        loading,
        openReworkDrawer,
        closeReworkDrawer,
        hasQcStatus,
        roundName,
        refreshReworkData,
    } = useReworkData(form.bid);
    const [currentBidForComments, setCurrentBidForComments] = useState("");
    const [batchData, setBatchData] = useState([]);
    const [text, setText] = useState([]);
    const { roleUserId } = useAuth();
    const { isReadOnly } = useFieldPermissions("cutting");
    const drawerOpenedForBid = useRef(null);
    const [isbnInput, setIsbnInput] = useState("");
    const [showRoundNameButton, setShowRoundNameButton] = useState(false);
    const [load, setLoad] = useState(false);
    const { accessToken } = useAuthToken();
    const [lockBidInput, setLockBidInput] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [rejectSubmissionData, setRejectSubmissionData] = useState(null);

    function filterUniqueScans(results) {
        const filteredResults = [];
        if (results.length === 0) {
            return filteredResults;
        }
        filteredResults.push(results[0]);
        for (let i = 1; i < results.length; ++i) {
            if (results[i].decodedText !== results[i - 1].decodedText) {
                filteredResults.push(results[i]);
            }
        }
        return filteredResults;
    }
    const [bookCover, setBookCover] = useState(false);
    const [regexLoaded, setRegexLoaded] = useState(false);

    const [masterData, setMasterData] = useState({
        bookFormat: [],
        condition: [],
        eqComplexityLevelFormula: [],
        bookFormatExceptions: [],
        language: [],
    });
    const [languageData, setLanguageData] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState("");
    const [langErrorMsg, setLangErrorMsg] = useState("");
    const UserDetails = JSON.parse(localStorage.getItem("user"));
    const LogoText = UserDetails?.name?.toUpperCase() || "U";

    useEffect(() => {
        return () => {
            Modal.destroyAll();
        };
    }, []);

    useEffect(() => {
        const fetchMasterData = async () => {
            try {
                const response = await fetch(CommonObj.Endpoints.GetMasterData, {
                    method: "GET",
                    mode: "cors",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setMasterData(data);
            } catch (error) {
                console.error("Failed to fetch master data:", error);
            }
        };

        fetchMasterData();
    }, []);

    useEffect(() => {
        const fetchLanguageData = async () => {
            try {
                const response = await fetch(CommonObj.Endpoints.GetLanguageListwithCode, {
                    method: "GET",
                    mode: "cors",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    },
                });


                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setLanguageData(data);
            } catch (error) {
                console.error("Failed to fetch language data:", error);
            }
        };

        fetchLanguageData();
    }, []);

    const isLanguageInactive = (langName) => {
        if (!langName || !Array.isArray(languageData)) return false;
        const searchName = String(langName).toLowerCase();
        const matched = languageData.find((ld) => {
            const dbName = ld.languageName ? String(ld.languageName).toLowerCase() : null;
            const dbCode = ld.languageCode ? String(ld.languageCode).toLowerCase() : null;
            return dbName === searchName || dbCode === searchName;
        });
        return matched ? matched.status === "0" : false;
    };
    useEffect(() => {
        if (selectedLanguage && languageData.length > 0) {
            if (isLanguageInactive(selectedLanguage)) {
                // setLangErrorMsg("This language is currently inactive.");
                message.warning("Selected language is currently inactive.");
            }
        }
    }, [selectedLanguage, languageData]);

    useEffect(() => {
        if (
            !form.bookFormat ||
            form.content.length === 0 ||
            masterData.eqComplexityLevelFormula.length === 0
        ) {
            setForm((prev) => ({ ...prev, eqComplexityLevel: "" }));
            return;
        }

        const bookFormatObj = masterData.bookFormat.find(
            (bf) => bf.format === form.bookFormat,
        );
        if (!bookFormatObj) return;

        const selectedConditionIds = form.content
            .map((contentName) => {
                const conditionObj = masterData.condition.find(
                    (c) => c.fileType === contentName,
                );
                return conditionObj ? conditionObj.id.toString() : null;
            })
            .filter((id) => id !== null);

        let bestMatch = null;
        for (const formula of masterData.eqComplexityLevelFormula) {
            if (formula.bookFormat !== bookFormatObj.id.toString()) {
                continue;
            }

            const formulaConditions = formula.condition.split(",");

            if (
                formulaConditions.length === selectedConditionIds.length &&
                formulaConditions.every((condId) =>
                    selectedConditionIds.includes(condId),
                )
            ) {
                bestMatch = formula;
                break;
            }
        }

        if (bestMatch) {
            setForm((prev) => ({ ...prev, eqComplexityLevel: bestMatch.level }));
            setErrors((prev) => ({
                ...prev,
                ["eqComplexityLevel"]: "",
            }));
        } else {
            setForm((prev) => ({ ...prev, eqComplexityLevel: "" }));
        }
    }, [form.bookFormat, form.content, masterData]);
    const saveComment = async () => {
        if (!currentBidForComments.trim()) {
            message.warning("No BID selected for saving comments.");
            return;
        }
        if (!form.comments.trim()) {
            message.warning("Please enter a comment before saving.");
            return;
        }
        const payload = {
            bid: currentBidForComments,
            comments: form.comments,
            createdBy: roleUserId,
        };
        setLoad(true);
        try {
            const response = await fetch(CommonObj.Endpoints.InsertComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                const result = await response.json();
                const errorMessage = result.error || result.message || `Error ${response.status}`;
                throw new Error(errorMessage);
            }
            message.success("Comment saved successfully!");
            setForm((prev) => ({ ...prev, comments: "" }));

            openCommentsSlider(currentBidForComments);
        } catch (error) {
            message.error({ content: error.message, duration: 5 });
        } finally {
            setLoad(false);
        }
    };

    const [errors, setErrors] = useState({});
    const [activeScanner, setActiveScanner] = useState(null);
    const [decodedResults, setDecodedResults] = useState([]);
    const [visible, setVisible] = useState(false);
    const [commentsvisible, setCommentsVisible] = useState(false);
    const [processingMode, setProcessingMode] = useState("single");
    const [commentsList, setCommentsList] = useState([]);

    const openCommentsSlider = async (bid) => {
        if (!bid) {
            message.warning("Please enter BID before viewing comments.");
            return;
        }

        setCurrentBidForComments(bid);
        try {
            const response = await fetch(CommonObj.Endpoints.GetComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    pageNo: 1,
                    pageSize: 10,
                    search: bid,
                }),
            });
            if (!response.ok) {
                throw new Error(`Status ${response.status}`);
            }
            const data = await response.json();

            setCommentsList(data);
            setCommentsVisible(true);
        } catch (error) {
            message.error(`Failed to fetch comments`);
        }
    };
    useEffect(() => {
        const loadRegexPatterns = async () => {
            try {
                await regexService.fetchRegexData(accessToken);
                await validationService.fetchRegexData(accessToken);
                setRegexLoaded(true);
            } catch (error) {
                console.error("Failed to load regex patterns:", error);
            }
        };
        if (accessToken) {
            loadRegexPatterns();
        }
    }, [accessToken]);
    const handleModeChange = (e) => {
        setProcessingMode(e.target.value);
    };
    useEffect(() => {
        const uniqueResults = filterUniqueScans(decodedResults);

        if (uniqueResults.length > 0 && activeScanner) {
            const latestResult = uniqueResults[uniqueResults.length - 1];
            const scannedValue = latestResult.decodedText;

            switch (activeScanner) {
                case "ISBN":
                    setForm((prev) => ({ ...prev, isbn: scannedValue }));
                    break;
                case "BID":
                    const bidError = validationService.validateBid(scannedValue);
                    if (bidError) {
                        message.error({ content: bidError, key: "bidScanValidation" });
                        break;
                    }
                    if (document.activeElement && document.activeElement.name === "bid") {
                        setIsbnInput(prev => prev ? prev + "," + scannedValue : scannedValue);
                    } else {
                        setForm((prev) => ({ ...prev, bid: "" }));
                        setIsbnInput(scannedValue);
                        UserLogin(scannedValue);
                    }
                    break;
                case "Rack & Shelf ID":
                    setForm((prev) => ({ ...prev, newRackShelf: scannedValue }));
                    break;
                default:
                    break;
            }
            setActiveScanner(null);
            setDecodedResults([]);
        }
    }, [decodedResults, activeScanner]);

    const onNewScanResult = (decodedText, decodedResult) => {
        setDecodedResults((prev) => [...prev, decodedResult]);
    };

    const handleContentChange = (e) => {
        const { name, value, checked } = e.target;

        setForm((prev) => {
            const currentContent = prev.content;

            if (checked) {
                return { ...prev, content: [...currentContent, value] };
            } else {
                return {
                    ...prev,
                    content: currentContent.filter((item) => item !== value),
                };
            }
        });
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => {
            const updatedForm = { ...prev, [name]: value };
            if (name === "condition" && value === "Used Condition") {
                updatedForm.usedCondition = "Acceptable";
            } else if (name === "condition" && value === "New Book") {
                updatedForm.usedCondition = "";
            }
            return updatedForm;
        });

        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: "" }));
        }
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const validate = () => {
        const newErrors = {};

        const bidError = validationService.validateBid(form.bid);
        if (!form.bid || !form.bid.trim()) {
            newErrors.bid = "Please Enter / Scan the BID number of the book";
        } else if (bidError) {
            newErrors.bid = bidError;
        }
        const isbnResult = validationService.validateISBN(form.isbn);
        if (!isbnResult.isValid) newErrors.isbn = isbnResult.error;

        const isbn10Result = validationService.validateISBN10(form.isbN10);
        if (!isbn10Result.isValid) newErrors.isbN10 = isbn10Result.error;

        const isbn13Result = validationService.validateISBN13(form.isbN13);
        if (!isbn13Result.isValid) newErrors.isbN13 = isbn13Result.error;

        // Required fields + regex pattern validation
        const titleError = validationService.validateTitle(form.title);
        if (titleError) newErrors.title = titleError === "Title is required" ? "Please Enter Title of the Book" : titleError;

        const authorError = validationService.validateAuthor(form.author);
        if (authorError) newErrors.author = authorError === "Author is required" ? "Please Enter Author of the Book" : authorError;

        const publisherError = validationService.validatePublisher(form.publisher);
        if (publisherError) newErrors.publisher = publisherError === "Publisher is required" ? "Please Enter Publisher of the Book" : publisherError;

        const languageError = validationService.validateLanguage(selectedLanguage);
        if (languageError) newErrors.language = languageError;

        const conditionError = validationService.validateCondition(form.condition);
        if (conditionError) newErrors.condition = conditionError;

        const bookTypeError = validationService.validateBookType(form.bookType);
        if (bookTypeError) newErrors.bookType = bookTypeError;

        const bookFormatError = validationService.validateBookFormat(form.bookFormat);
        if (bookFormatError) newErrors.bookFormat = bookFormatError;

        const rackShelfError = validationService.validateRackAndShelf(form.newRackShelf);
        if (rackShelfError) newErrors.newRackShelf = rackShelfError;

        // Rack shelf regex validation
        if (!validationService.isMissing(form.newRackShelf) && regexLoaded) {
            const val = regexService.validateRackShelf(form.newRackShelf.trim());
            if (!val.isValid) newErrors.newRackShelf = "Input format invalid: No matching pattern found.";
        }

        // Page count
        const pageCountResult = validationService.validatePageCount(form.bookPageCount);
        if (!pageCountResult.isValid) newErrors.bookPageCount = pageCountResult.error;

        // Content
        const contentError = validationService.validateContent(form.content);
        if (contentError) newErrors.content = contentError;

        // Conditional: Used Condition
        const usedConditionError = validationService.validateUsedCondition(form.usedCondition, form.condition);
        if (usedConditionError) newErrors.usedCondition = usedConditionError;

        // Conditional: EQ-Complexity or Exception
        const isException = form.bookFormat === "Exceptions";
        if (isException && validationService.isMissing(form.reasonForException)) {
            newErrors.reasonForException = "Reason for exception is required when book type is Exceptions";
        } else {
            const eqError = validationService.validateEQComplexityLevel(form.eqComplexityLevel, form.bookFormat);
            if (eqError) newErrors.eqComplexityLevel = eqError;
        }

        validateRackShelfLogic(newErrors);

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };



    const validateRackShelfLogic = (errors) => {
        const newRack = form.newRackShelf?.trim();
        if (!newRack) {
            errors.newRackShelf = "Rack and Shelf is required";
            return;
        }

        const isSame = removeSpaces(form.rackShelf).toLowerCase() === removeSpaces(newRack).toLowerCase();
        if (isSame) {
            errors.newRackShelf = "Must not be the same as current Rack Shelf.";
        } else if (regexLoaded && !regexService.validateRackShelf(newRack).isValid) {
            errors.newRackShelf = "Input format invalid: No matching pattern found.";
        }
    };
    const [isDisabled, setIsDisabled] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();

        setTemporaryDisable();
        if (!validate()) return;

        const submissionData = prepareSubmissionData();

        if (submissionData.title) {
            await processSubmission(submissionData);
        }
    };

    const setTemporaryDisable = () => {
        setIsDisabled(true);
        setTimeout(() => setIsDisabled(false), 2000);
    };

    const prepareSubmissionData = () => {
        return {
            bid: form.bid.trim(),
            updatedPageCount: form.updbookPageCount,
            isSelfFixed: false,
            userId: roleUserId,
            createdBy: roleUserId,
            rackShelf: form.newRackShelf.trim() || "",
            qcStatus: 1,
            isbn: form.isbn,
            title: form.title,
            author: form.author,
            publisher: form.publisher,
            isbN10: form.isbN10.trim(),
            isbN13: form.isbN13.trim(),
            pageCount: Number(form.bookPageCount),
            language: selectedLanguage,
            weight: form.weight || 0.75,
            format: form.bookFormat,
            condition: form.condition,
            usedCondition: form.usedCondition || "0",
            content: Array.isArray(form.content) ? form.content.join(",") : form.content,
            eqComplexityLevel: form.bookFormat !== "Exceptions" ? form.eqComplexityLevel : undefined,
            formatException: Number(form.formatException) || 0,
            bookCoverImageURL: bookCover,
            bookType: form.bookType,
            comments: form.comments,
            version: "1.0",
            rackAndShelf: 1,
            ErrorCount: "",
            ErrorCommand: "",
            bidScanTime: form.bidScanTime,
        };
    };

    const processSubmission = async (submissionData) => {
        try {
            const response = await fetch(CommonObj.Endpoints.SubmitCuttingProcess, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(submissionData),
            });
            const result = await response.json();
            if (!response.ok) {
                const errorMessage = result.error || result.message || `Error ${response.status}`;
                throw new Error(errorMessage);
            }
            handleSuccess(submissionData);
            resetFormState();
        } catch (error) {
            message.error({ content: error.message, duration: 5 });
            setLockBidInput(false);
        }
    };

    const handleSuccess = (data) => {
        if (data.condition === "Used Condition" && data.usedCondition === "Unacceptable") {
            message.success("Book got cancelled due to unacceptable wear level");
        } else {
            message.success("Cutting Completed successfully. Books are ready for scanning.");
        }
    };

    const resetFormState = () => {
        setShowRoundNameButton(false);
        drawerOpenedForBid.current = null;
        setIsbnInput("");
        setCommentsList([]);
        setErrors({});
        setSelectedLanguage("");
        setForm({
            bid: "", title: "", author: "", publisher: "", isbN10: "", isbN13: "",
            bookPageCount: "", language: "", weight: "0.75", isbn: "", condition: "",
            bookType: "", usedCondition: "", content: [], bookFormat: "",
            eqComplexityLevel: "", rackAndShelf: "", comments: "",
            reasonForException: "", formatException: "", newRackShelf: "",
            rackShelf: "", version: "1.0", bidScanTime: "", vendorName: ""
        });
        setLockBidInput(false);
    };
    async function UserLogin(bid) {
        const bidfetch = await fetchBIDStatus(bid);
        if (bidfetch) return;
        setLoad(true);
        try {
            const response = await fetchBookData(bid);
            if (!response.ok) throw new Error(`Response status: ${response.status}`);

            const result = await response.json();

            if (result?.length > 0) {
                handleSuccessfulLogin(result[0], bid);
                setLockBidInput(true);
            } else {
                handleEmptyLogin();
                setLockBidInput(false);
            }

        } catch (error) {
            setShowRoundNameButton(false);
            setLockBidInput(false);
            console.error(error.message);
        }
        finally {
            setLoad(false);
        }
    }

    const fetchBookData = (bid) => {
        return fetch(CommonObj.Endpoints.GetBookByBIDandStatus, {
            method: "POST",
            mode: "cors",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "X-CSRF-Token": encryptTimestamp(),
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ bid, createdBy: roleUserId }),
        });
    };



    const handleSuccessfulLogin = async (bookData, bid) => {
        setErrors({});
        setForm({
            ...form,
            bid: bookData.bid || form.bid,
            title: bookData.title,
            author: bookData.author,
            publisher: bookData.publisher,
            isbN10: bookData.isbN10,
            isbN13: bookData.isbN13,
            bookPageCount: bookData.pageCount,
            language: bookData.language,
            weight: bookData.weight || "0.75",
            isbn: bookData.isbn || form.isbn,
            bookFormat: bookData.format || form.bookFormat,
            condition: bookData.condition || form.condition,
            usedCondition: bookData.usedCondition || form.usedCondition,
            eqComplexityLevel: bookData.eqComplexityLevel || form.eqComplexityLevel,
            content: bookData.content?.split(",") || [],
            rackShelf: bookData.rackShelf || form.rackShelf,
            rackAndShelf: bookData.rackAndShelf || form.rackAndShelf,
            bookType: bookData.bookType || form.bookType,
            reasonForException: bookData.reasonForException || form.reasonForException,
            formatException: Number(bookData.formatException) || form.formatException,
            bidScanTime: bookData.bidScanTime || "",
            vendorName: bookData.vendorName || "",
        });

        setBookCover(bookData.bookCoverImageURL);
        setSelectedLanguage(bookData.language);
        fetchCommentCount(bookData.bid || bid);
        checkReworkStatus(bid);
    };

    const checkReworkStatus = async (bid) => {
        const hasRework = await refreshReworkData(bid);
        if (hasRework && drawerOpenedForBid.current !== bid) {
            drawerOpenedForBid.current = bid;
            setShowRoundNameButton(true);
            openReworkDrawer();
        }
    };
    const handleLanguageChange = (e) => {
        const { name, value } = e.target;
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
        setSelectedLanguage(value);
        setForm((prev) => ({ ...prev, language: value }));
    };

    const handleEmptyLogin = () => {
        setIsbnInput("");
        setCommentsList({});
        setErrors({});
        setShowRoundNameButton(false);
        setSelectedLanguage("");
        setForm({
            bid: "",
            title: "", author: "", publisher: "", isbN10: "", isbN13: "",
            bookPageCount: "", updbookPageCount: "", language: "", weight: "0.75",
            isbn: "", condition: "", bookType: "", usedCondition: "", content: [],
            bookFormat: "", eqComplexityLevel: "", rackAndShelf: "", comments: "",
            reasonForException: "", formatException: "", rackShelf: "",
            version: "1.0", qc: "", vendorName: "",
        });
        setLockBidInput(false);
        drawerOpenedForBid.current = null;
    };
    const isSelectedMissingFromMaster = selectedLanguage && !masterData.language.some(
        (lang) => lang.languageName === selectedLanguage
    );
    const fetchBIDStatus = async (bid) => {
        const url = CommonObj.Endpoints.GetBatchBIDStatus;

        const requestData = {
            bid: bid,
            createdBy: roleUserId,
        };

        try {
            const response = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            if (response.ok) {
                const errorResponse = await response.json();
                if (errorResponse.message) {
                    message.error(errorResponse.message);
                    handleEmptyLogin();
                    return true;
                } else {
                    return false;
                }
            } else if (!response.ok) {
                const errorResponse = await response.json();
                message.error(errorResponse.message || errorResponse.error || "Failed to retrieve BID status.");
                if (errorResponse.message || errorResponse.error) {
                    handleEmptyLogin();
                    return true;
                }
            }
            return false;
        } catch (error) {
            return false;
        }
    };
    const handleFormKeyDown = (e) => {
        if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    };
    const handleClear = () => {
        if (form.bid || form.newRackShelf || form.comments) {
            ConfirmationModal.showClearConfirmation(() => {
                setIsbnInput("");
                setSelectedLanguage("");
                setForm({
                    bid: "",
                    title: "",
                    author: "",
                    publisher: "",
                    isbN10: "",
                    isbN13: "",
                    bookPageCount: "",
                    language: "",
                    weight: 0.75,
                    isbn: "",
                    condition: "",
                    usedCondition: "",
                    content: [],
                    bookFormat: "",
                    eqComplexityLevel: "",
                    rackAndShelf: "",
                    comments: "",
                    reasonForException: "",
                    version: "",
                    rackShelf: "",
                    newRackShelf: "",
                    vendorName: "",
                });
                setCommentsList([]);
                setErrors({});
                setShowRoundNameButton(false);
                setLockBidInput(false);
                drawerOpenedForBid.current = null;
            });
        }
    };

    const fetchCommentCount = async (bid) => {
        if (!bid) return;

        try {
            const response = await fetch(CommonObj.Endpoints.GetComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    pageNo: 1,
                    pageSize: 10,
                    search: bid,
                }),
            });
            if (!response.ok) {
                throw new Error(`Status ${response.status}`);
            }
            const data = await response.json();
            setCommentsList(data);
        } catch (error) {
            console.error(`Failed to fetch comments`);
        }
    };

    const populateFieldsByIsbn = async (bid) => {
        setForm((prev) => ({
            ...prev,
            bid: "",
        }));
        UserLogin(bid);
    };
    const handleIsbnBlur = () => {
        if (form.bid && form.bid.trim() !== "" && form.bid.trim().length !== 16) {
            message.error("The BID should be 16 characters");
            return;
        } else if (form.bid && form.bid.trim() !== ""){
            const bidError = validationService.validateBid(form?.bid);
            if (bidError) {
                message.error(bidError);
                return;
            }
        }
        //if (selectedLanguage && isLanguageInactive(selectedLanguage)) {
        //    message.warning("Selected language is currently inactive.");
        //}
        if (isbnInput.trim() !== "") {
            populateFieldsByIsbn(isbnInput);
        }
    };

    const handleSubmitIsbn = (e) => {
        setForm((prev) => ({
            ...prev,
            bid: "",
        }));
    };

    const handleBlur = () => {
        if (form.bid) {
            UserLogin(form.bid);
        }
    };

    const handleIsbnInputChange = (e) => {
        const value = e.target.value;
        setIsbnInput(value);

        if (value.trim() === "") {
            setForm({
                bid: "",
                title: "",
                author: "",
                publisher: "",
                isbN10: "",
                isbN13: "",
                bookPageCount: "",
                language: "",
                weight: 0.75,
                isbn: "",
                condition: "",
                bookType: "",
                usedCondition: "",
                content: [],
                bookFormat: "",
                eqComplexityLevel: "",
                comments: "",
                reasonForException: "",
                rackAndShelf: "",
                    rackShelf: "",
                    newRackShelf: "",
                    version: 1.0,
                    vendorName: "",
                });
            setShowRoundNameButton(false);
            setBookCover("");
            setSelectedLanguage([]);
            setErrors({});
            drawerOpenedForBid.current = null;
        } else {
            setForm((prev) => ({ ...prev, bid: "" }));
        }
    };

    const lastEnterPressTime = useRef(0);
    const lastBidKeyTimeRef = useRef(0);
    const clearBidTimerRef = useRef(null);

    useEffect(() => {
        return () => {
            clearTimeout(clearBidTimerRef.current);
        };
    }, []);

    const handleIsbnKeyPress = (e) => {
        if (isReadOnly("bid")) {
            return;
        }

        if (e.key === "Enter") {
            e.preventDefault();
            const now = Date.now();
            if (now - lastEnterPressTime.current < 3000) {
                return; // Throttle to 3000ms
            }
            lastEnterPressTime.current = now;

            if (form.bid && form.bid.trim() !== "" && form.bid.trim().length !== 16) {
                message.error("The BID should be 16 characters");
                return;
            } else if (form.bid && form.bid.trim() !== ""){
                const bidError = validationService.validateBid(form?.bid);
                if (bidError) {
                    message.error(bidError);
                    return;
                }
            }
            if (isbnInput.trim() !== "") {
                populateFieldsByIsbn(isbnInput);
            }
        }
    };

    const handleIsbnReadOnlyKeyDown = (e) => {
        if (!isReadOnly("bid")) {
            return;
        }

        // Let native copy/paste behave normally (no custom clipboard handling).
        const isCopyOrPasteShortcut =
            (e.ctrlKey || e.metaKey) && ["c", "v", "C", "V"].includes(e.key);
        if (isCopyOrPasteShortcut) {
            return;
        }

        if (e.key === 'Enter' || e.key === 'Tab') {
            return;
        }

        const currentTime = Date.now();
        const timeDiff = currentTime - lastBidKeyTimeRef.current;
        lastBidKeyTimeRef.current = currentTime;

        // A physical scanner sends characters within a few milliseconds of each
        // other, so only block keystrokes that arrive slowly (manual typing).
        // The very first keystroke (field currently empty) is always let through
        // so a scan burst never loses its first character.
        const isSlowManualKeystroke = timeDiff > 50 && e.currentTarget.value.length > 0;
        if (!isSlowManualKeystroke) {
            return;
        }

        e.preventDefault();
        setIsbnInput('');

        clearTimeout(clearBidTimerRef.current);
        clearBidTimerRef.current = setTimeout(() => {
            showManualEntryDisabledWarning();
        }, 300);
    };

    const handleNumericKeyDown = (event) => {
        if (["e", "E", "+", "-", "."].includes(event.key)) {
            event.preventDefault();
        }
    };
    function MasterRadio(item) {
        return (
            <div className="book-page-form-radio-button">
                <input
                    type="radio"
                    name={item?.name}
                    id="book-page-form-radio-binding-t1-book"
                    value={item?.data?.format}
                    checked={item?.value === item?.data?.format}
                    onChange={handleChange}
                />
                <label htmlFor="book-page-form-radio-binding-t1-book">
                    {item?.data?.format}
                </label>
            </div>
        );
    }

    function MasterCheckbox(item) {
        return (
            <div className="book-page-form-checkbox-button">
                <input
                    type="checkbox"
                    id="used-condition-content1"
                    name={item?.name}
                    value={item?.data?.fileType}
                    checked={form?.content?.includes(item?.data?.fileType)}
                    onChange={handleContentChange}
                />
                <label htmlFor="used-condition-content">{item?.data?.fileType}</label>
            </div>
        );
    }

    const showRejectModal = (record) => {
        if (!validate()) return;
        const submissionData = prepareSubmissionData();
        console.log("reject model open");
        setIsModalVisible(true);
        setRejectSubmissionData(submissionData);
    };
    const getInputClass = (value, baseClass = "book-page-form-input-text") => {
        const hasValue =
            value !== null &&
            value !== undefined &&
            (typeof value === "number" || String(value).trim() !== "");

        return `${baseClass}${hasValue ? " has-text" : ""}`;
    };
    return (
        <>
            <IntakeSlide
                isModalVisible={isModalVisible}
                setIsModalVisible={setIsModalVisible}
                clearForm={resetFormState}
                title={"Cutting Reject"}
                rejectSubmissionData={rejectSubmissionData}
                oldRackandShelf={form?.rackShelf}
                onScannerOpen={(scanner) => { setActiveScanner(scanner) }}
                emptyDecode={() => { setDecodedResults([]) }}
                className="story-slider slider-with-footer"
                width={540}
            />
            <Modal
                title={`Scan ${activeScanner ? activeScanner : ""}`}
                open={!!activeScanner}
                onCancel={() => setActiveScanner(null)}
                footer={null}
                destroyOnClose
                width={1000}
                className="scan-model-container"
            >
                <div className="scan-modal">
                    <Html5QrcodePlugin
                        fps={30}
                        qrbox={{ width: 1000, height: 400 }}
                        aspectRatio={2.8}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
                    />
                </div>
            </Modal>
            <SliderUI
                visible={visible}
                width={450}
                title="Book Slide"
                onClose={() => setVisible(false)}
                imageSrc={bookCover ? bookCover : BookCoverDummy}
                bookTitle={form.title}
                isbn={form.isbn}
                bid={form.bid}
                bookscover={true}
                mode={processingMode}
                className="story-slider"
                modeBatch={text}
                batchData={batchData}
            />
            <SliderUI
                visible={commentsvisible}
                width={390}
                title="Comments Slide"
                onClose={() => setCommentsVisible(false)}
                bookTitle={`Comments For BID : ${form.bid}`}
                commentsList={commentsList}
                commentsCount={commentsList.length > 0 ? commentsList[0].totalRows : 0}
                username={form.createdBy}
                form={form}
                setForm={setForm}
                saveComment={saveComment}
                load={load}
                className="story-slider comment-slider-drawer-1"
            />

            <ErrorCommentsSlider
                visible={reworkDrawerVisible}
                onClose={closeReworkDrawer}
                reworkData={reworkData}
                loading={loading}
                hasQcStatus={hasQcStatus}
            />
            <main className="book-page-main-container">
                <div className="book-page-container">
                    <div className="book-page-title-container no-padding-right">
                        <div className="book-page-title">
                            <span>
                                <img src={CuttingIcon} alt="Cutting Icon"></img>
                            </span>

                            <h2>Begin The Cutting Process</h2>
                        </div>
                        <div className="book-page-title-container-2">
                            <button
                                className="book-page-title-icon"
                                onClick={() => setVisible(true)}
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M4 6V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9C20 7.34315 18.6569 6 17 6H4ZM4 6V5"
                                        stroke="#0009E2"
                                        strokeWidth="1.5"
                                    />
                                    <circle
                                        opacity="0.5"
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#009DDB"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 6.00002V6.75002H18.75V6.00002H18ZM15.7172 2.32614L15.6111 1.58368L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619H4.81353L4.91959 3.86865ZM5.07107 6.00002V6.75002H18V6.00002V5.25002H5.07107V6.00002ZM18 6.00002H18.75V4.30604H18H17.25V6.00002H18ZM15.7172 2.32614L15.6111 1.58368L4.81353 3.12619L4.91959 3.86865L5.02566 4.61111L15.8232 3.0686L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619C3.91638 3.25435 3.25 4.0227 3.25 4.92895H4H4.75C4.75 4.76917 4.86749 4.63371 5.02566 4.61111L4.91959 3.86865ZM18 4.30604H18.75C18.75 2.63253 17.2678 1.34701 15.6111 1.58368L15.7172 2.32614L15.8232 3.0686C16.5763 2.96103 17.25 3.54535 17.25 4.30604H18ZM5.07107 6.00002V5.25002C4.89375 5.25002 4.75 5.10627 4.75 4.92895H4H3.25C3.25 5.9347 4.06532 6.75002 5.07107 6.75002V6.00002Z"
                                        fill="#0009E2"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10 19H14"
                                        stroke="#009DDB"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                {processingMode === "single" ? (
                                    ""
                                ) : (
                                    <span>{batchData.length}</span>
                                )}
                            </button>
                            <div className="book-page-title-radio-group">
                                <p>Processing Mode:</p>
                                <Radio.Group onChange={handleModeChange} value={processingMode}>
                                    <Radio value="single" data-track="cutting-mode-single">Single book</Radio>
                                    <Radio value="batch" data-track="cutting-mode-batch">Batch Processing</Radio>
                                </Radio.Group>
                            </div>
                        </div>
                    </div>
                    {processingMode === "single" ? (
                        <form
                            className="book-page-form no-right-padding"
                            onSubmit={handleSubmit}
                            onKeyDown={handleFormKeyDown}
                            noValidate
                        >
                            <div className="flex-container-BID">
                                <div className="book-page-camera-button-container multiple rounded-button">
                                    <Input
                                        placeholder=""
                                        value={isbnInput}
                                        className={`${isbnInput ? "has-id" : ""}`}
                                        onChange={(e) => {
                                            handleIsbnInputChange(e);
                                        }}
                                        onBlur={() => {
                                            handleIsbnBlur();
                                        }}
                                        onKeyDown={(e) => {
                                            handleIsbnReadOnlyKeyDown(e);
                                            handleIsbnKeyPress(e);
                                        }}
                                        id="cutting-isbn-input-id"
                                    />
                                    {isbnInput.length === 0 && (
                                        <label htmlFor="cutting-isbn-input-id">
                                            {isReadOnly("bid") ? "Scan " : "Enter / Scan "}BID Number Using “
                                            <strong>Camera Icon</strong>”
                                            <span className="form-required">*</span>
                                        </label>
                                    )}
                                    <button
                                        type="button"
                                        className="book-page-camera-button"
                                        data-track="cutting-open-bid-scanner"
                                        onClick={() => { setDecodedResults([]); setActiveScanner("BID"); }}
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="12"
                                                cy="13"
                                                r="3"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M10 19.9999H14C16.8089 19.9999 18.2134 19.9999 19.2223 19.3258C19.659 19.0339 20.034 18.6589 20.3259 18.2222C21 17.2133 21 15.8088 21 12.9999C21 10.191 20.9999 8.78673 20.3257 7.77783C20.0339 7.34107 19.6589 6.96607 19.2221 6.67423C18.2132 6.00011 16.8088 6.00011 13.9999 6.00011H9.99985C7.19093 6.00011 5.78646 6.00011 4.77757 6.67423C4.34081 6.96607 3.96581 7.34107 3.67397 7.77783C3 8.7865 3 10.1903 3 12.998L3 12.9999C3 15.8088 3 17.2133 3.67412 18.2222C3.96596 18.6589 4.34096 19.0339 4.77772 19.3258C5.78661 19.9999 7.19108 19.9999 10 19.9999Z"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                            />
                                            <path
                                                d="M18 10H17.5"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M14.5 3.5H9.5"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                                fill="url(#paint0_linear_273_6917)"
                                            />
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                                fill="url(#paint1_linear_273_6917)"
                                            />
                                            <defs>
                                                <linearGradient
                                                    id="paint0_linear_273_6917"
                                                    x1="22.601"
                                                    y1="11.9503"
                                                    x2="1.98296"
                                                    y2="14.3301"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stopColor="#033D9B" />
                                                    <stop offset="1" stopColor="#29ACD5" />
                                                </linearGradient>
                                                <linearGradient
                                                    id="paint1_linear_273_6917"
                                                    x1="22.601"
                                                    y1="11.9503"
                                                    x2="1.98296"
                                                    y2="14.3301"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stopColor="#033D9B" />
                                                    <stop offset="1" stopColor="#29ACD5" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </button>
                                    <button
                                        type="button"
                                        className="book-page-camera-button-input-2"
                                        onClick={handleSubmitIsbn}
                                    >
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967C9.67678 6.76256 9.67678 7.23744 9.96967 7.53033L12.4393 10L9.96967 12.4697C9.67678 12.7626 9.67678 13.2374 9.96967 13.5303C10.2626 13.8232 10.7374 13.8232 11.0303 13.5303L14.0303 10.5303C14.3232 10.2374 14.3232 9.76256 14.0303 9.46967L11.0303 6.46967ZM5.96967 6.46967C6.26256 6.17678 6.73744 6.17678 7.03033 6.46967L10.0303 9.46967C10.3232 9.76256 10.3232 10.2374 10.0303 10.5303L7.03033 13.5303C6.73744 13.8232 6.26256 13.8232 5.96967 13.5303C5.67678 13.2374 5.67678 12.7626 5.96967 12.4697L8.43934 10L5.96967 7.53033C5.67678 7.23744 5.67678 6.76256 5.96967 6.46967Z"
                                                fill="url(#paint0_linear_1900_8687)"
                                            />
                                            <defs>
                                                <linearGradient
                                                    id="paint0_linear_1900_8687"
                                                    x1="20.6"
                                                    y1="9.94475"
                                                    x2="-0.0696504"
                                                    y2="12.0919"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stopColor="#033D9B" />
                                                    <stop offset="1" stopColor="#29ACD5" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </button>
                                </div>
                                {form?.bid && showRoundNameButton && (
                                    <button
                                        type="button"
                                        className="round-btn"
                                        onClick={openReworkDrawer}
                                    >
                                        {roundName}{" "}
                                        <span>
                                            <svg
                                                width="14"
                                                height="14"
                                                viewBox="0 0 14 14"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clipPath="url(#clip0_4317_52426)">
                                                    <circle
                                                        opacity="0.5"
                                                        cx="7.0013"
                                                        cy="6.99935"
                                                        r="5.83333"
                                                        stroke="#DC1400"
                                                        strokeWidth="0.875"
                                                    />
                                                    <path
                                                        d="M6.125 5.25L7.875 7L6.125 8.75"
                                                        stroke="#DC1400"
                                                        strokeWidth="0.875"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_4317_52426">
                                                        <rect width="14" height="14" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </span>
                                    </button>
                                )}
                            </div>
                            <div className="book-page-form-container">
                                <div className="book-page-form-1">
                                    <div className="field-group">
                                        <input
                                            id="bid"
                                            name="bid"
                                            className={getInputClass(form?.bid)}
                                            value={form.bid}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder=""
                                            required
                                            disabled={lockBidInput}
                                            readOnly={isReadOnly("bid")}
                                        />
                                        <label htmlFor="bid" className="label">
                                            Book Id (BID){" "}
                                            <span className="form-required">*</span>
                                        </label>
                                        {errors.bid && (
                                            <span className="error-msg">{errors.bid}</span>
                                        )}
                                    </div>

                                    <div className="field-group">
                                        <input
                                            id="main-isbn"
                                            name="isbn"
                                            className={getInputClass(form?.isbn)}
                                            value={form.isbn}
                                            onChange={handleChange}
                                            placeholder=""
                                            disabled
                                            required
                                        />
                                        <label htmlFor="main-isbn" className="label">
                                            Book Number (ISBN){" "}
                                        </label>
                                        {errors.isbn && (
                                            <span className="error-msg">{errors.isbn}</span>
                                        )}
                                    </div>
                                    <div className="field-group">
                                        <input
                                            id="isbN10"
                                            name="isbN10"
                                            className={getInputClass(form?.isbN10)}
                                            value={form.isbN10}
                                            onChange={handleChange}
                                            placeholder=""
                                            readOnly={isReadOnly("isbN10")}
                                        />
                                        <label htmlFor="isbN10" className="label">
                                            ISBN-10 <span className="form-required">*</span>
                                        </label>
                                        {errors.isbN10 && (
                                            <span className="error-msg">{errors.isbN10}</span>
                                        )}
                                    </div>
                                    <div className="field-group">
                                        <input
                                            id="isbN13"
                                            name="isbN13"
                                            className={getInputClass(form?.isbN13)}
                                            value={form.isbN13}
                                            onChange={handleChange}
                                            placeholder=""
                                            readOnly={isReadOnly("isbN13")}
                                        />
                                        <label htmlFor="isbN13" className="label">
                                            ISBN-13 <span className="form-required">*</span>
                                        </label>
                                        {errors.isbN13 && (
                                            <span className="error-msg">{errors.isbN13}</span>
                                        )}
                                    </div>
                                    {form.bookFormat !== "Exceptions" && (
                                        <div className="field-group">
                                            <select
                                                id="eqComplexityLevel"
                                                name="eqComplexityLevel"
                                                className={getInputClass(form?.eqComplexityLevel)}
                                                value={form.eqComplexityLevel || ""}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value=""></option>
                                                <option value="1A">1A</option>
                                                <option value="2A">2A</option>
                                                <option value="3A">3A</option>
                                                <option value="4A">4A</option>
                                                <option value="5A">5A</option>
                                                <option value="1B">1B</option>
                                                <option value="2B">2B</option>
                                                <option value="3B">3B</option>
                                                <option value="4B">4B</option>
                                                <option value="5B">5B</option>
                                            </select>
                                            <label htmlFor="eqComplexityLevel" className="label">
                                                EQ-Complexity Level{" "}
                                                <span className="form-required">*</span>
                                            </label>
                                            {errors.eqComplexityLevel && (
                                                <span className="error-msg">
                                                    {errors.eqComplexityLevel}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="book-page-form-2">
                                    <div className="field-group">
                                        <input
                                            id="title"
                                            name="title"
                                            className={getInputClass(form?.title)}
                                            value={form.title}
                                            onChange={handleChange}
                                            placeholder=""
                                            readOnly={isReadOnly("title")}
                                        />
                                        <label htmlFor="title" className="label">
                                            Title <span className="form-required">*</span>
                                        </label>
                                        {errors.title && (
                                            <span className="error-msg">{errors.title}</span>
                                        )}
                                    </div>
                                    <div className="field-group">
                                        <input
                                            id="author"
                                            name="author"
                                            className={getInputClass(form?.author)}
                                            value={form.author}
                                            onChange={handleChange}
                                            placeholder=""
                                            readOnly={isReadOnly("author")}
                                        />
                                        <label htmlFor="author" className="label">
                                            Author <span className="form-required">*</span>
                                        </label>
                                        {errors.author && (
                                            <span className="error-msg">{errors.author}</span>
                                        )}
                                    </div>
                                    <div className="field-group">
                                        <input
                                            id="publisher"
                                            name="publisher"
                                            className={getInputClass(form?.publisher)}
                                            value={form.publisher}
                                            onChange={handleChange}
                                            placeholder=""
                                            readOnly={isReadOnly("publisher")}
                                        />
                                        <label htmlFor="publisher" className="label">
                                            Publisher <span className="form-required">*</span>
                                        </label>
                                        {errors.publisher && (
                                            <span className="error-msg">{errors.publisher}</span>
                                        )}
                                    </div>
                                    <div className="field-group">
                                        <input
                                            id="bookPageCount"
                                            name="bookPageCount"
                                            className={getInputClass(form?.bookPageCount)}
                                            type="number"
                                            value={form.bookPageCount}
                                            onChange={handleChange}
                                            placeholder=""
                                            onKeyDown={handleNumericKeyDown}
                                            readOnly={isReadOnly("bookPageCount")}
                                        />
                                        <label htmlFor="bookPageCount" className="label">
                                            Page Count <span className="form-required">*</span>
                                        </label>
                                        {errors.bookPageCount && (
                                            <span className="error-msg">{errors.bookPageCount}</span>
                                        )}
                                    </div>

                                    <div className="field-group">
                                        <select
                                            id="language"
                                            name="language"
                                            className={`book-page-form-input-text ${selectedLanguage ? "has-text" : ""}`}
                                            value={selectedLanguage}
                                            onChange={handleLanguageChange}
                                            required
                                        >
                                            <option value=""></option>
                                            {isSelectedMissingFromMaster && (
                                                <option value={selectedLanguage} disabled>
                                                    {selectedLanguage}
                                                </option>
                                            )}

                                            {masterData.language.map((language) => {
                                                const isInactive = isLanguageInactive(language.languageName);
                                                const isCurrentlySelected = selectedLanguage === language.languageName;
                                                return (
                                                    <option
                                                        key={language.languageName}
                                                        value={language.languageName || selectedLanguage}
                                                        disabled={language.status == 0}
                                                    >
                                                        {language.languageName}

                                                    </option>
                                                );
                                            })}
                                        </select>

                                        <label htmlFor="language" className="label">
                                            Language <span className="form-required">*</span>
                                        </label>
                                        {errors.language && !langErrorMsg && (
                                            <span className="error-msg">{errors.language}</span>
                                        )}
                                        {langErrorMsg && (
                                            <span className="error-msg">{langErrorMsg}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="book-page-form-3">
                                    <div className="book-page-form-radio-container">
                                        <p className="book-page-form-radio-title">
                                            Binding<span className="form-required">*</span>
                                        </p>
                                        <div className="book-page-form-radio-button-container">
                                            <div className="book-page-form-radio-button">
                                                <input
                                                    type="radio"
                                                    name="bookType"
                                                    id="book-page-form-radio-text-book"
                                                    value="Textbook"
                                                    checked={form.bookType === "Textbook"}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="book-page-form-radio-text-book">
                                                    Textbook
                                                </label>
                                            </div>
                                            <div className="book-page-form-radio-button">
                                                <input
                                                    type="radio"
                                                    name="bookType"
                                                    id="book-page-form-radio-grade-book"
                                                    value="Tradebook"
                                                    checked={form.bookType === "Tradebook"}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="book-page-form-radio-grade-book">
                                                    Tradebook
                                                </label>
                                            </div>
                                        </div>
                                        {errors.bookType && (
                                            <span className="error-msg-rad">{errors.bookType}</span>
                                        )}
                                    </div>
                                    <div className="book-page-form-radio-container">
                                        <p className="book-page-form-radio-title">
                                            Condition<span className="form-required">*</span>
                                        </p>
                                        <div className="book-page-form-radio-button-container">
                                            <div className="book-page-form-radio-button">
                                                <input
                                                    type="radio"
                                                    name="condition"
                                                    id="book-page-form-radio-new-book"
                                                    value="New Book"
                                                    checked={form.condition === "New Book"}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="book-page-form-radio-new-book">
                                                    New Book
                                                </label>
                                            </div>
                                            <div className="book-page-form-radio-button">
                                                <input
                                                    type="radio"
                                                    name="condition"
                                                    id="book-page-form-radio-new-book"
                                                    value="Used Condition"
                                                    checked={form.condition === "Used Condition"}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="book-page-form-radio-new-book">
                                                    Used Condition
                                                </label>
                                            </div>
                                        </div>
                                        {errors.condition && (
                                            <span className="error-msg-rad">{errors.condition}</span>
                                        )}
                                    </div>
                                    {form.condition === "Used Condition" && (
                                        <div className="book-page-form-radio-container">
                                            <p className="book-page-form-radio-title">
                                                Wear Level<span className="form-required">*</span>
                                            </p>
                                            <div className="book-page-form-radio-button-container">
                                                <div className="book-page-form-radio-button">
                                                    <input
                                                        type="radio"
                                                        id="used-condition-acceptable"
                                                        name="usedCondition"
                                                        value="Acceptable"
                                                        //*checked={form.usedCondition === "Acceptable"}*/
                                                        checked={true}
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="used-condition-acceptable">
                                                        Acceptable
                                                    </label>
                                                </div>

                                                <div className="book-page-form-radio-button" style={{ display: 'none' }}>
                                                    <input
                                                        type="radio"
                                                        id="used-condition-unacceptable"
                                                        name="usedCondition"
                                                        value="Unacceptable"
                                                        checked={form.usedCondition === "Unacceptable"}
                                                        onChange={handleChange}
                                                        style={{ cursor: "no-drop" }}
                                                        hidden
                                                    />
                                                    <label htmlFor="used-condition-unacceptable">
                                                        Unacceptable
                                                    </label>
                                                </div>
                                            </div>
                                            {errors.usedCondition && (
                                                <span className="error-msg-rad">
                                                    {errors.usedCondition}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                    <div className="book-page-form-radio-container">
                                        <p className="book-page-form-radio-title">
                                            Book Type <span className="form-required">*</span>
                                        </p>
                                        <div className="book-page-form-radio-button-container">
                                            {masterData?.bookFormat?.length > 0
                                                ? masterData?.bookFormat?.map((item) => {
                                                    return item.format !== "Exceptions" && (
                                                        <MasterRadio
                                                            data={item}
                                                            name="bookFormat"
                                                            value={form?.bookFormat}
                                                            style={{
                                                                cursor: (item.format === "Exceptions" || form?.bookFormat === "Exceptions")
                                                                    ? "not-allowed"
                                                                    : "auto"
                                                            }}
                                                            disabled
                                                        />
                                                    );
                                                })
                                                : ""}
                                        </div>
                                        {errors.bookFormat && (
                                            <span className="error-msg-rad">{errors.bookFormat}</span>
                                        )}
                                    </div>
                                    {form.bookFormat === "Exceptions" && (
                                        <div className="field-group" style={{ display: 'none' }}>
                                            <select
                                                id="formatException"
                                                name="formatException"
                                                className={getInputClass(form?.formatException)}
                                                value={form?.formatException || ""}
                                                onChange={handleChange}
                                                //*required*
                                                style={{ cursor: "no-drop", display: 'none' }}
                                                disabled
                                                hidden
                                            >
                                                <option value=""></option>

                                                {masterData.bookFormatExceptions.map((exception) => (
                                                    <option key={exception.id} value={exception.id}>
                                                        {exception.exceptionType}
                                                    </option>
                                                ))}
                                            </select>
                                            <label htmlFor="formatException" className="label">
                                                Reason for Exception{" "}
                                                <span className="form-required">*</span>
                                            </label>
                                            {errors.formatException && (
                                                <span className="error-msg">
                                                    {errors.formatException}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div className="book-page-form-checkbox-container">
                                        <p className="book-page-form-checkbox-title">
                                            Content <span className="form-required">*</span>
                                        </p>
                                        <div className="book-page-form-checkbox-button-container">
                                            {masterData?.condition?.length > 0
                                                ? masterData?.condition?.map((item) => {
                                                    return (
                                                        <MasterCheckbox data={item} name="content" />
                                                    );
                                                })
                                                : ""}
                                        </div>
                                        {errors.content && (
                                            <span className="error-msg-rad">{errors.content}</span>
                                        )}
                                    </div>
                                    <input
                                        id="weight"
                                        name="weight"
                                        className={getInputClass(form?.weight)}
                                        type="number"
                                        value={form.weight}
                                        onChange={handleChange}
                                        placeholder="Weight (grams)"
                                        hidden
                                    />
                                    <div className="current-rack-self-container">
                                        <label htmlFor="current-rack-self" className="">
                                            Current Rack Shelf{" "}
                                            <span className="form-required">*</span>
                                        </label>
                                        <input
                                            id="current-rack-self"
                                            name="current-rack-self"
                                            className="current-rack-self-input"
                                            value={form.rackShelf}
                                            onChange={handleChange}
                                            disabled
                                        />
                                        {errors.rackShelf && (
                                            <span className="error-msg">{errors.rackShelf}</span>
                                        )}
                                    </div>
                                    <div className="book-page-form-scan-rack-container">
                                        <span className="form-required-rack">*</span>
                                        <input
                                            className="book-page-form-scan-rack-button"
                                            id="rackAndShelf"
                                            name="newRackShelf"
                                            placeholder="Enter / Scan Rack Shelf Barcode"
                                            value={form.newRackShelf}
                                            onChange={handleChange}
                                            required
                                        ></input>
                                        <button
                                            style={{ cursor: "pointer" }}
                                            className="book-page-form-scan-rack-button-icon"
                                            data-track="cutting-open-rack-scanner"
                                            type="button"
                                            onClick={() => {
                                                setDecodedResults([]);
                                                setActiveScanner("Rack & Shelf ID");
                                            }}
                                        >
                                            <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <circle
                                                    cx="12"
                                                    cy="13"
                                                    r="3"
                                                    stroke="#1C274C"
                                                    strokeWidth="1.5"
                                                />
                                                <path
                                                    opacity="0.5"
                                                    d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                                    stroke="#1C274C"
                                                    strokeWidth="1.5"
                                                />
                                                <path
                                                    d="M18 10H17.5"
                                                    stroke="#1C274C"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />
                                                <path
                                                    opacity="0.5"
                                                    d="M14.5 3.5H9.5"
                                                    stroke="#1C274C"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />
                                            </svg>
                                            <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                                    fill="url(#paint0_linear_1086_13736)"
                                                />
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                                    fill="url(#paint1_linear_1086_13736)"
                                                />
                                                <defs>
                                                    <linearGradient
                                                        id="paint0_linear_1086_13736"
                                                        x1="22.601"
                                                        y1="11.9503"
                                                        x2="1.98296"
                                                        y2="14.3301"
                                                        gradientUnits="userSpaceOnUse"
                                                    >
                                                        <stop stopColor="#033D9B" />
                                                        <stop offset="1" stopColor="#29ACD5" />
                                                    </linearGradient>
                                                    <linearGradient
                                                        id="paint1_linear_1086_13736"
                                                        x1="22.601"
                                                        y1="11.9503"
                                                        x2="1.98296"
                                                        y2="14.3301"
                                                        gradientUnits="userSpaceOnUse"
                                                    >
                                                        <stop stopColor="#033D9B" />
                                                        <stop offset="1" stopColor="#29ACD5" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                        </button>
                                        <span className="error-msg-rad">{errors.newRackShelf}</span>
                                    </div>
                                    <div className="field-group">
                                        <input
                                            id="vendorName"
                                            name="vendorName"
                                            className={getInputClass(form.vendorName)}
                                            value={form.vendorName}
                                            readOnly
                                        />
                                        <label htmlFor="vendorName" className="label">
                                            Vendor
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="book-page-form-4">
                                <div className="field-group">
                                    <button
                                        className="book-page-form-view-comments"
                                        type="button"
                                        onClick={() => openCommentsSlider(form.bid)}
                                    >
                                        {`View Comments (${commentsList.length > 0 ? commentsList[0].totalRows : 0})`}{" "}
                                    </button>

                                    <textarea
                                        id="comments"
                                        rows="4"
                                        value={form.comments}
                                        onChange={(e) =>
                                            setForm((prev) => ({ ...prev, comments: e.target.value }))
                                        }
                                        className={`${"book-page-form-input-textarea"} ${form.content === "" ? "" : "has-text"
                                            }`}
                                    ></textarea>
                                    <label htmlFor="comments">Comments</label>
                                </div>
                            </div>

                            <div className="book-page-footer-container">
                                <div
                                    className="book-page-action-container"
                                    style={{ justifyContent: "right" }}
                                >
                                    <div className="book-page-buttons-container justify-space">
                                        <button
                                            type="button"
                                            className="reject-button"
                                            onClick={handleClear}
                                        >
                                            Clear
                                        </button>
                                        <button className="accept-button" disabled={isDisabled}>
                                            Submit
                                        </button>
                                        <button className="reject-button" type="button" disabled={isDisabled} onClick={() => showRejectModal()}>Reject</button>

                                    </div>
                                </div>
                            </div>
                        </form>
                    ) : (
                        <BatchProcess
                            title="Begin The Batch Process"
                            onDataChange={setBatchData}
                            onBatch={setText}
                        />
                    )}
                </div>
            </main>
        </>
    );
};
export default CuttingForm;


